import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import { sectionBackgrounds, resolveGradient } from '../../theme';
import { isInternalAppPath } from '../../utils/internalPath';
const Hero = ({ label, title, subtitle, primaryCta, secondaryCta, backgroundImage, gradient, }) => {
    const theme = useTheme();
    const background = backgroundImage
        ? `linear-gradient(135deg, rgba(0, 40, 85, 0.88), rgba(30, 61, 107, 0.82)), url(${backgroundImage}) center/cover no-repeat`
        : resolveGradient(gradient, sectionBackgrounds.hero);
    return (_jsx(Box, { component: "section", sx: {
            minHeight: '60vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background,
            color: theme.palette.primary.contrastText,
            textAlign: 'center',
            py: 4,
            px: 2,
            transition: 'background 0.4s ease',
        }, children: _jsxs(Box, { sx: { maxWidth: 672 }, children: [label && (_jsx(Typography, { variant: "overline", sx: { display: 'block', mb: 1, opacity: 0.9, letterSpacing: 1.5 }, children: label })), _jsx(Typography, { variant: "h1", component: "h1", gutterBottom: true, sx: { textShadow: '0 2px 12px rgba(0,0,0,0.15)' }, children: title }), subtitle && (_jsx(Typography, { variant: "h6", sx: { opacity: 0.95, mb: 3, fontWeight: 500 }, children: subtitle })), _jsxs(Stack, { direction: { xs: 'column', sm: 'row' }, spacing: 2, justifyContent: "center", flexWrap: "wrap", children: [primaryCta && (_jsx(Button, { ...(isInternalAppPath(primaryCta.href)
                                ? { component: RouterLink, to: primaryCta.href }
                                : { href: primaryCta.href }), variant: "contained", color: "secondary", size: "large", sx: {
                                color: theme.palette.secondary.contrastText,
                                fontWeight: 600,
                                px: 3,
                                '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(197,160,40,0.35)' },
                            }, children: primaryCta.label })), secondaryCta && (_jsx(Button, { ...(isInternalAppPath(secondaryCta.href)
                                ? { component: RouterLink, to: secondaryCta.href }
                                : { href: secondaryCta.href }), variant: "outlined", size: "large", sx: {
                                color: theme.palette.primary.contrastText,
                                borderColor: 'rgba(255,255,255,0.7)',
                                fontWeight: 600,
                                px: 3,
                                transition: 'all 0.25s ease',
                                '&:hover': {
                                    borderColor: theme.palette.primary.contrastText,
                                    bgcolor: 'rgba(255,255,255,0.12)',
                                    transform: 'translateY(-1px)',
                                },
                            }, children: secondaryCta.label }))] })] }) }));
};
export default Hero;
